import { Brand } from "../../store/slices/environmentSlice";

import {
  ROOT,
  SIGN_IN,
  AGENCY_REGISTRATION,
  AGENT_REGISTRATION,
  FORGOTTEN_PASSWORD,
  RESET_PASSWORD,
  SSO_GATEWAY,
} from "./routes";

export type LayoutChrome = {
  showHeader?: boolean;
  showFooter?: boolean;
};

const DEFAULT_CHROME: LayoutChrome = {
  showHeader: true,
  showFooter: true,
};

export const ROUTE_CHROME_BY_BRAND: Record<
  string,
  Partial<Record<Brand, LayoutChrome>>
> = {
  [ROOT]: {
    vid: { showHeader: true, showFooter: true },
  },
  [SIGN_IN]: {
    vid: { showHeader: false, showFooter: false },
  },
  [AGENCY_REGISTRATION]: {
    vid: { showHeader: true, showFooter: false },
  },
  [AGENT_REGISTRATION]: {
    vid: { showHeader: true, showFooter: false },
  },
  [FORGOTTEN_PASSWORD]: {
    vid: { showHeader: true, showFooter: false },
  },
  [RESET_PASSWORD]: {
    vid: { showHeader: true, showFooter: false },
  },
  [SSO_GATEWAY]: {
    vid: { showHeader: false, showFooter: false },
  },
};

export const getLayoutChrome = (
  routePath: string,
  brand: Brand,
): LayoutChrome => {
  const byRoute = ROUTE_CHROME_BY_BRAND[routePath];

  if (!byRoute) {
    return DEFAULT_CHROME;
  }

  return {
    ...DEFAULT_CHROME,
    ...(byRoute.default ?? {}),
    ...(byRoute[brand] ?? {}),
  };
};
